import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/vue-query";
import type { Ref } from "vue";

export const INBOX_PAGE_SIZE = 20;

export function useAdminInboxUnreadCount() {
  const auth = useAuth();
  const client = useNuxtApp().$client;
  const enabled = computed(
    () => auth.status.value === "authenticated"
  );
  return useQuery({
    queryKey: ["inbox", "unreadCount"],
    queryFn: () => client.inbox.unreadCount.query(),
    staleTime: 30_000,
    enabled,
  });
}

export function useAdminInboxList(enabled: Ref<boolean>) {
  const client = useNuxtApp().$client;
  const queryClient = useQueryClient();

  const unreadCountQuery = useQuery({
    queryKey: ["inbox", "unreadCount"],
    queryFn: () => client.inbox.unreadCount.query(),
    staleTime: 30_000,
  });

  const listInfiniteQuery = useInfiniteQuery({
    queryKey: ["inbox", "list"],
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      client.inbox.list.query({
        limit: INBOX_PAGE_SIZE,
        cursor: pageParam,
      }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    enabled,
  });

  const markAllReadMutation = useMutation({
    mutationFn: () => client.inbox.markAllRead.mutate(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["inbox"] });
    },
  });

  return {
    unreadCountQuery,
    listInfiniteQuery,
    markAllReadMutation,
  };
}
